import { useState, type FormEvent } from 'react';
import { Alert, Box, Button, Card, CardContent, Link, TextField, Typography } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { login } from '../api/auth';
import { useAuth } from '../store/AuthContext';

export function Login() {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const r = await login(email, password);
      setSession(r.token, r.user);
      navigate('/dashboard', { replace: true });
    } catch (err: unknown) {
      const message =
        (err as { response?: { data?: { error?: string } } })?.response?.data?.error ?? 'Login failed';
      setError(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
      <Card elevation={3} sx={{ width: 420 }}>
        <CardContent>
          <Typography variant="h4" component="h1" gutterBottom>
            Sign In
          </Typography>
          {error && (
            <Alert severity="error" role="alert" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Email *"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              variant="standard"
              fullWidth
              autoFocus
            />
            <TextField
              label="Password *"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              variant="standard"
              fullWidth
            />
            <Button type="submit" variant="contained" color="primary" disabled={submitting}>
              SIGN IN
            </Button>
          </Box>
          <Typography variant="body2" sx={{ mt: 2 }}>
            New here?{' '}
            <Link component={RouterLink} to="/register/dev" underline="always">
              Register as a developer
            </Link>{' '}
            or{' '}
            <Link component={RouterLink} to="/register/manager" underline="always">
              register as a manager
            </Link>
            .
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
